import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SiteModeService {
    private _siteMinimalMode$ = new BehaviorSubject<boolean>(false);
    public editMode: boolean = false;
    public focusedElem: focusElement = focusElement.NoFocus;
    constructor() {}

    public getMinimalMode$(): Observable<boolean> {
        return this._siteMinimalMode$.asObservable().pipe();
    }

    public setMinimalMode$(minimalMode: boolean): void {
        this._siteMinimalMode$.next(minimalMode);
    }
}
export enum focusElement {
    UpTitle = 'UpTitle',
    Title = 'title',
    SubTitle = 'subTitle',
    Counter = 'counter',
    Question = 'question',
    Answer = 'answer',
    LessonText = 'LessonText',
    DedicationName = 'DedicationName',
    DedicationDate = 'DedicationDate',
    DedicationText = 'DedicationText',
    LessonSource = 'LessonSource',
    FileName = 'FileName',
    Rabbi = 'rabbi',
    DateCreated = 'datecreated',
    DateLesson = 'datelesson',
    DateQuestion = 'DateQuestion',
    DateLearning = 'datelearning',
    DateUpdate = 'dateupdate',
    CategoryParent = 'categoryparent',
    CategoryMiddle = 'categorymiddle',
    CategoryChild = 'categorychild',
    NoFocus = 'NoFocus',
    AskerName = 'AskerName',
    AskerAge = 'AskerAge',
    AskerAdress = 'AskerAdress',
    AskerPhone = 'AskerPhone',
    AskerMail = 'AskerMail',
    //SHIUR PARAMS
    Priority = 'Priority',
    NameOfFile = 'NameOfFile',
    PdfFile = 'PdfFile',
    Audio = 'Audio',
    Video = 'Video',
    ForRead = 'ForRead',
    Picture = 'Picture',
    ToPublish = 'ToPublish',
    ShortLessonsPrev = 'ShortLessonsPrev',
    InternalNotesTitle = 'InternalNotesTitle',
    Popularity = 'Popularity',
    DailyLearning = 'DailyLearning',
    BetMidrash = 'BetMidrash',
    numOfVidMin = 'numOfVidMin',
    numOfContent = 'numOfContent',
    NotesManagerTitle = 'NotesManagerTitle',
    daysToAns = 'daysToAns',
    htmlLink = 'htmlLink',
    contQues = 'contQues',
    similarQuestion = 'similarQuestion',
}
